import { GAME_SIZES as GAME_SIZES_CORE, GAME_WIDTHS as GAME_WIDTHS_CORE } from '@core/js/components/common/GamesView/constants';

export * from '@core/js/components/common/GamesView/constants';

export const GAME_SIZES = {
    ...GAME_SIZES_CORE,
    CUSTOM: 'custom'
};

export const GAME_WIDTHS = {
    ...GAME_WIDTHS_CORE,
    [GAME_SIZES.CUSTOM]: {
        MOBILE: 120,
        DESKTOP: 160
    }
};
